module.exports = __webpack_public_path__ + "img/ico-arrow-next.fe5242dd.svg";